import { render, staticRenderFns } from "./RequestDoctor.vue?vue&type=template&id=654b99c0&"
import script from "./RequestDoctor.vue?vue&type=script&lang=ts&"
export * from "./RequestDoctor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports